import React, {useState} from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { BlackMask } from '../../../../components/mask'
import { Iconfont } from '../../../../components/icon/iconfont'
import DisplayTransition from '../../../../desktop/components/transitions/display-transition'
import { BigButton } from '../../../../components/button'
import { FormattedMessage } from 'react-intl'


export const Content = props => {
    useStyles(classes)
    const {content} = props
    return <div className={classes.Content}>
        <div className={classes.Bd} dangerouslySetInnerHTML={{__html: content}}/>
        <BigButton className={classes.Button} onClick={props.onClose}>
            <FormattedMessage id="confirm" defaultMessage="Confirm"/>
        </BigButton>
        <Iconfont onClick={props.onClose} className={classes.Close}>&#xe7c9;</Iconfont>
    </div>
}


const ContentEditor = props => {
    useStyles(classes)
    return <React.Fragment>
        <DisplayTransition in={props.show} style={{zIndex: props.zIndex}} className={classes.AskContainer}>
            <div>
                <Content {...props} />
            </div>
        </DisplayTransition>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}

export default props => {
    useStyles(classes)
    const [show, setShow] = useState(false)

    const clickHandle = e => {
        e.preventDefault()
        e.stopPropagation()
        setShow(true)
    }

    return <>
        {
            props?.content && <span className={classes.Ask} onClick={clickHandle}>?</span>
        }
        <ContentEditor {...props} show={show} onClose={(e) => {
            e.preventDefault()
            e.stopPropagation()
            setShow(false)
        }} />
    </>
}